import React from 'react';
import { useIntl } from 'react-intl';

import TextFieldDefault, { TextFieldDefaultProps } from './TextFieldDefault/TextFieldDefault';
import Wysiwyg from './Wysiwyg';

const ContentRich = React.forwardRef((props: TextFieldDefaultProps, ref: any) => {
  const { label, placeholder, ...rest } = props;
  const intl = useIntl();

  return (
    <TextFieldDefault
      ref={ref}
      label={label || intl.formatMessage({ id: 'POSTS.FORM.CONTENT' })}
      placeholder={placeholder || intl.formatMessage({ id: 'POSTS.FORM.CONTENT' })}
      {...rest}
      slotProps={{
        input: {
          inputComponent: Wysiwyg,
        },
      }}
    />
  );
});

ContentRich.displayName = 'ContentRich';

export default ContentRich;
